var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',{staticClass:"mt-15",attrs:{"align-center":"","justify-center":""}},[_c('v-flex',[_c('address-form',{attrs:{"theme":_vm.theme,"loading":_vm.loading,"errors":_vm.errors,"action":"create"},on:{"submit":_vm.submit},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }